import { styled } from 'baseui';

export default styled('div', ({ $theme }) => {
  return {
    marginBottom: '12px',
    color: '#97a0c0',
    ...$theme.typography.panelTitle500,
  };
});
